import gql from 'graphql-tag';

export default gql`
  mutation UpdateContactUs($updateContactUsId: ID!, $data: ContactUsUpdateInput!) {
    updateContactUs(id: $updateContactUsId, data: $data) {
      id
      name
      number
      email
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdateContactUs.ts